// Shared italic caption used under embedded media (videos, screenshots).
//
// Single source of truth for the look — change it once and every caption on
// the marketing site updates. Defaults to <p>; pass `as="figcaption"` when
// the caption sits inside a <figure>.
import type { ElementType, ReactNode } from "react";

type Props = {
  children: ReactNode;
  /** Element to render. Use "figcaption" inside a <figure>. */
  as?: ElementType;
  className?: string;
};

const BASE_CLASS =
  "mt-3 text-center font-body text-[13.5px] italic leading-[1.5] text-secondary";

export function MediaCaption({ children, as: As = "p", className }: Props) {
  return (
    <As className={className ? `${BASE_CLASS} ${className}` : BASE_CLASS}>
      {children}
    </As>
  );
}
